import { render } from "./edit-bank-account.vue?vue&type=template&id=97e35b6a"
import script from "./edit-bank-account.vue?vue&type=script&lang=js"
export * from "./edit-bank-account.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__